import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import env from './env';
import { FlowType } from '../types';

const invite = i18n.createInstance();
invite
  .use(Backend)
  .use(LanguageDetector)
  .init({
    detection: {
      order: ['querystring', 'localStorage'],
      lookupQuerystring: 'lang',
    },
    debug: env.type !== 'production',
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: ['en', 'de', 'pl', 'it', 'fr'],
    lowerCaseLng: true,
    fallbackLng: 'en',
    backend: {
      loadPath: `/locales/{{lng}}/translation.json?v=${env.version}`,
    },
  });

const registration = i18n.createInstance();
registration
  .use(Backend)
  .use(LanguageDetector)
  .init({
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
    },
    debug: env.type !== 'production',
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: ['en', 'de', 'pl', 'it', 'fr'],
    lowerCaseLng: true,
    fallbackLng: 'en',
    backend: {
      loadPath: `/locales/{{lng}}/translation.json?v=${env.version}`,
    },
  });

const getTranslation = (flow) => (FlowType.REGISTRATION === flow ? registration : invite);

export default {
  invite,
  registration,
  getTranslation,
};
